export enum FontType {
  PRIMARY_BOLD = "/fonts/opensans-bold.woff2",
  PRIMARY_SEMIBOLD = "/fonts/opensans-semibold.woff2",
  PRIMARY_REGULAR = "/fonts/opensans-regular.woff2",
  SECONDARY_SEMIBOLD = "/fonts/montserrat-semibold.woff2",
  SECONDARY_REGULAR = "/fonts/montserrat-regular.woff2",
  SECONDARY_LIGHT = "/fonts/montserrat-light.woff2",
}
